import axios from "axios";

axios.defaults.headers.common["x-access-token"] = localStorage.getItem("token");
const url = process.env.REACT_APP_BACKEND_URL;

export const GetMyActiveServers = async () => {
  return await axios.get(url + "api/GetmyActiveServers");
};
